import React from "react";

const ACNotCooling = () => {
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold">AC Not Cooling — Repair Service</h1>
      <p className="mt-4">
        Our technicians diagnose AC cooling problems, inspect compressors,
        refrigerant levels, and airflow to restore cooling quickly.
      </p>
    </div>
  );
};

export default ACNotCooling;

